export const QUESTIONS = [
  {
    key: "leads",
    title: "When a new inquiry arrives, what happens?",
    options: [
      "Someone follows up when they can",
      "We have reminders, but still chase it",
      "Every lead has an owner and a next step",
    ],
  },
  {
    key: "work",
    title: "How does your team keep work moving?",
    options: [
      "Texts, paper, and people remembering",
      "A few tools with information copied between them",
      "One shared workflow with clear handoffs",
    ],
  },
  {
    key: "payments",
    title: "What happens with quotes and invoices?",
    options: [
      "We create and chase them manually",
      "Some reminders work; exceptions need chasing",
      "Quotes, invoices, and status are connected",
    ],
  },
  {
    key: "visibility",
    title: "How do you find out what needs attention?",
    options: [
      "I ask around or check several places",
      "I have reports, but they need updating",
      "I can see current work and exceptions together",
    ],
  },
];
const PLAYBOOK = {
  leads: {
    title: "Give every lead a next step",
    why: "A shared follow-up process keeps new inquiries from depending on someone remembering.",
    first:
      "List last week’s inquiries. Give each one an owner, a next action, and a due date.",
    build:
      "Connect your website, calls, and inbox to a lead pipeline with reminders and draft replies.",
    measure: "Track time to first response and inquiries with no next action.",
  },
  work: {
    title: "Connect the office and the field",
    why: "Shared job records reduce repeat questions and copying between tools.",
    first:
      "Pick one recurring job. Write down who starts it, who takes over, and what “done” means.",
    build:
      "Create a shared job board or mobile workflow for status, photos, approvals, and handoffs.",
    measure:
      "Count repeated status questions and handoffs missing information.",
  },
  payments: {
    title: "Make quoting and invoicing repeatable",
    why: "A consistent workflow helps your team send the right document and see what is outstanding.",
    first:
      "Make one quote template and one checklist for turning an approved job into an invoice.",
    build:
      "Connect quotes, approvals, invoices, and payment reminders to the same customer record.",
    measure: "Track time to send a quote and the number of overdue invoices.",
  },
  visibility: {
    title: "Give the owner one place to look",
    why: "A useful owner view surfaces work that needs a decision before it becomes a fire drill.",
    first:
      "Choose three daily questions: what is overdue, what is blocked, and who needs a decision?",
    build:
      "Bring those answers into an owner dashboard with a short daily summary.",
    measure: "Track time spent assembling updates and unresolved blockers.",
  },
};
export function buildOpportunityPlan(answers) {
  if (
    !answers ||
    QUESTIONS.some(
      (q) =>
        !Number.isInteger(answers[q.key]) ||
        answers[q.key] < 0 ||
        answers[q.key] > 2,
    )
  )
    throw new Error("Answer all four workflow questions.");
  return QUESTIONS.map((q, i) => ({
    ...PLAYBOOK[q.key],
    key: q.key,
    answer: q.options[answers[q.key]],
    priority:
      answers[q.key] === 2
        ? "Fine-tune"
        : answers[q.key] === 1
          ? "Connect the gaps"
          : "Start here",
    order: answers[q.key] * 10 + i,
  }))
    .sort((a, b) => a.order - b.order)
    .slice(0, 3)
    .map(({ order, ...item }) => item);
}
export function planText(plan) {
  return (
    "YOUR AI OPPORTUNITY PLAN\nBetter Systems AI\n\nBased on your answers; a starting point, not a measured savings forecast.\n\n" +
    plan
      .map(
        (p, i) =>
          `${i + 1}. ${p.title}\nYour answer: ${p.answer}\n${p.why}\nTry first: ${p.first}\nWhat we can build: ${p.build}\nMeasure: ${p.measure}`,
      )
      .join("\n\n") +
    "\n\nOptional 15-minute call: https://www.bettersystems.ai/book"
  );
}
